<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                {{'businessIntelligence.relatorioTaxa.dealers'}}
              </div>
              <span #dealers class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                {{dealer.nome}}
                <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
              </span>
              <div class="botao">
                <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                  <em class="fa fa-plus"></em>
                </button>
              </div>
              <div class="clear"></div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.relatorioTaxa.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [maxDate]="maxDate" [yearNavigator]="true"
                  [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataInicial()"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.relatorioTaxa.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [maxDate]="maxDate" [yearNavigator]="true"
                  [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataFinal()"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-6">
                <button pButton type="button" class="p-button-sm p-button-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'businessIntelligence.relatorioTaxa.filtrar' | translate}}
                  <i class="pi pi-search ml-1"></i>
                </button>
                <!--! Remoção por redundancia -->
                <!-- <button pButton type="button" class="p-button-sm p-button-secondary mt-3 mr-2" icon="pi pi-filter-slash"
                  iconPos="right" (click)="limparFiltros()" pTooltip="Limpar Filtros">
                </button> -->
                <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                  translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                  {{'businessIntelligence.relatorioTaxa.maisFiltros'}}
                  <em class="fa fa-filter"></em>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <app-loading [exibir]="carregando"></app-loading>
    <div *ngIf="!carregando">

      <div translate *ngIf="registros?.length <= 0" class="sem-registros text-muted mt-2">
        {{'businessIntelligence.relatorioTaxa.nenhumRegistroExibir'}}
      </div>
      <p-table #dt id="principal" *ngIf="registros?.length > 0" [columns]="columnsSynthetic" [value]="registros"
        class="style" styleClass="p-datatable-striped p-datatable-sm mt-2" [rowHover]="true" [autoLayout]="true"
        [autoLayout]="true">
        <div class="content">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-container *ngFor="let col of columnsSynthetic">
                <th class="text-center" [translate]="getTranslate(col.header)" [pSortableColumn]="col.field">
                  {{col.header}}
                  <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
                </th>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-registros let-columns="columnsSynthetic" let-rowIndex="rowIndex">
            <tr>
              <ng-container *ngFor="let col of columnsSynthetic">
                <td *ngIf="col.field != 'natendidas'" class="text-center">
                  {{ registros[col.field] }}
                </td>
                <td *ngIf="col.field == 'natendidas'" class="text-center">
                  <a class="link" (click)="getDealerCode(rowIndex)">
                    {{ registros[col.field] }}
                  </a>
                </td>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="styleFooter">
              <td></td>
              <td [translate]="getTranslate(nomeTotais)" class="text-center">
                {{nomeTotais}}
              </td>
              <td class="text-center">
                {{totalSolicitadas| number}}
              </td>
              <td class="text-center">
                {{totalAtendidas | number}}
              </td>
              <td class="text-center">
                <a class="link" style="color: white" (click)="getDealerCode(null)">
                {{totalNAtendidas | number}}
                </a>
              </td>
              <td class="text-center">
                {{totalPercentual | percent: '1.0-0'}}
              </td>
            </tr>
          </ng-template>
        </div>
      </p-table>
    </div>

    <div *ngIf="registrosAnalitico?.length > 0" class="mt-3">
      <hr>
      <p-table #dt id="target" [columns]="selectedColumnsAnalytical" [value]="registrosAnalitico" class="style"
        styleClass="p-datatable-striped p-datatable-sm mt-4" [rowHover]="true" [autoLayout]="true" [autoLayout]="true"
        [paginator]="registrosAnalitico.length > 10" [rows]="rowsAn" [(first)]="firstAn" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'businessIntelligence.relatorioTaxa.mostrandoRegistrosAnalitico' | translate}}"
        [rowsPerPageOptions]="[10,20,30,50,100]">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of selectedColumnsAnalytical">
              <th class="text-center" [translate]="getTranslate(col.header)" [ngStyle]="{'width': col.width}">
                {{col.header}}
                <!-- <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" /> -->
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-registrosAnalitico let-columns="selectedColumnsAnalytical" let-rowIndex="rowIndex">
          <tr>
            <ng-container *ngFor="let col of selectedColumnsAnalytical">
              <td *ngIf="col.field != 'description' && col.field != 'message'" class="text-center">
                <div [translate]="getTranslate(registrosAnalitico[col.field])">
                  {{ col.type ? col.type.transform(registrosAnalitico[col.field], col.arg1, col.arg2) : registrosAnalitico[col.field] }}
                  <ng-container *ngIf="col.field == 'serviceType'" [translate]="getTranslate(registrosAnalitico)">
                  </ng-container>
                </div>
              </td>
              <td *ngIf="col.field == 'description'" class="text-center link-comments"
                (click)="abrirComentarios(rowIndex)" pTooltip="Clique Aqui para Visualizar">
                <p class="comentarios">{{ registrosAnalitico[col.field] }}</p>
              </td>
              <td *ngIf="col.field == 'message'" class="text-center link-comments" (click)="abrirMensagens(rowIndex)"
                pTooltip="Clique Aqui para Visualizar">
                <p class="comentarios">{{ registrosAnalitico[col.field] }}</p>
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'businessIntelligence.relatorioTaxa.filtros.grupoEconomico'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'businessIntelligence.relatorioTaxa.filtros.grupoEconomicoPlaceHolder' | translate }}"
            [options]="gruposEconomicos" optionLabel="descricao" optionValue="id" formControlName="grupo_economico"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'businessIntelligence.relatorioTaxa.filtros.numeroOS'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'businessIntelligence.relatorioTaxa.filtros.numeroOSPlaceHolder' | translate}}"
            formControlName="numeroOS">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'businessIntelligence.relatorioTaxa.filtros.codItem'}}
        </div>
        <div class="col col-8">
          <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
            placeholder="{{'businessIntelligence.relatorioTaxa.filtros.codItemPlaceHolder' | translate}}"
            formControlName="codItem">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'businessIntelligence.relatorioTaxa.filtros.classificacao'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'businessIntelligence.relatorioTaxa.filtros.classificacaoPlaceHolder' | translate }}"
            [options]="classificacao" optionLabel="descricao" optionValue="id" formControlName="classificacao"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'businessIntelligence.relatorioTaxa.filtrar'}}</button>
  </ng-template>
</p-dialog>

<!-- <p-dialog header="{{'businessIntelligence.relatorioTaxa.selecioneDealers' | translate}}"
  [(visible)]="displayFiltrosDealers" [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->
<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-dialog header="{{'businessIntelligence.relatorioTaxa.comentarios' | translate}}" [(visible)]="displayComentarios"
  [style]="{width: '500px'}" [modal]="true" [draggable]="false" (onHide)="fecharComentarios()">
  <textarea cols="58" rows="10" disabled>
    {{ textoComment }}
  </textarea>
</p-dialog>

<p-dialog header="{{'businessIntelligence.relatorioTaxa.mensagens' | translate}}" [(visible)]="displayMensagens"
  [style]="{width: '500px'}" [modal]="true" [draggable]="false" (onHide)="fecharMensagens()">
  <textarea cols="58" rows="10" disabled>
    {{ textoMessage }}
  </textarea>
</p-dialog>

<p-toast key="businessIntelligenceDetalhado" position="bottom-right"></p-toast>
